import { Link, useLocation } from "react-router-dom";
import { BRAND } from "../lib/constants";

export default function BrandHeader({ adminMode = false }) {
  const location = useLocation();
  return (
    <header className="w-full border-b border-[rgba(106,13,173,0.08)] bg-[#FAF8F4]/85 backdrop-blur-xl sticky top-0 z-40 no-print">
      <div className="max-w-7xl mx-auto px-5 md:px-10 py-5 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" data-testid="brand-link">
          <img src="/logo.png" alt="Pancha Healing" className="w-11 h-11 rounded-full object-cover ring-1 ring-[#D4A855]/40" />
          <div>
            <div className="font-serif text-xl text-[#2C0A5E] leading-none">{BRAND.name}</div>
            <div className="ph-overline mt-1">{BRAND.tagline}</div>
          </div>
        </Link>
        <nav className="flex items-center gap-3 md:gap-5 text-sm">
          {adminMode && (
            <>
              <Link to="/admin/dashboard" className={`transition ${location.pathname.includes("dashboard") ? "text-[#6A0DAD]" : "text-[#6B5E7E] hover:text-[#6A0DAD]"}`} data-testid="nav-dashboard">Dashboard</Link>
              <Link to="/admin/orders" className={`transition ${location.pathname.includes("orders") && !location.pathname.includes("abandoned") ? "text-[#6A0DAD]" : "text-[#6B5E7E] hover:text-[#6A0DAD]"}`} data-testid="nav-orders">Orders</Link>
              <Link to="/admin/abandoned" className={`transition ${location.pathname.includes("abandoned") ? "text-[#6A0DAD]" : "text-[#6B5E7E] hover:text-[#6A0DAD]"}`} data-testid="nav-abandoned">Abandoned</Link>
              <Link to="/admin/new-order" className={`transition ${location.pathname.includes("new-order") ? "text-[#6A0DAD]" : "text-[#6B5E7E] hover:text-[#6A0DAD]"}`} data-testid="nav-new-order">New Order</Link>
              <Link to="/admin/inventory" className={`transition ${location.pathname.includes("inventory") ? "text-[#6A0DAD]" : "text-[#6B5E7E] hover:text-[#6A0DAD]"}`} data-testid="nav-inventory">Inventory</Link>
              <Link to="/admin/vedic-calendar" className={`transition ${location.pathname.includes("vedic-calendar") ? "text-[#6A0DAD]" : "text-[#6B5E7E] hover:text-[#6A0DAD]"}`} data-testid="nav-vedic-calendar">Calendar</Link>
              <Link to="/admin/personal-year-meanings" className={`transition ${location.pathname.includes("personal-year-meanings") ? "text-[#6A0DAD]" : "text-[#6B5E7E] hover:text-[#6A0DAD]"}`} data-testid="nav-personal-year-meanings">PY Copy</Link>
              <button
                onClick={() => { localStorage.removeItem("ph-admin"); window.location.href = "/admin"; }}
                className="ph-btn-ghost text-sm"
                data-testid="nav-logout"
              >Logout</button>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}
